module.exports = __webpack_public_path__ + "static/media/matching_tutorial_keencap_up.ebd2f2c7.png";